import { render, staticRenderFns } from "./ProviderEntityInvoiceCompanyModal.vue?vue&type=template&id=4960e916&scoped=true&"
import script from "./ProviderEntityInvoiceCompanyModal.vue?vue&type=script&lang=js&"
export * from "./ProviderEntityInvoiceCompanyModal.vue?vue&type=script&lang=js&"
import style0 from "./ProviderEntityInvoiceCompanyModal.vue?vue&type=style&index=0&id=4960e916&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4960e916",
  null
  
)

component.options.__file = "ProviderEntityInvoiceCompanyModal.vue"
export default component.exports